<template>
    <div>
        <div class="topTitle" :class="{'location':isFixed}" :style="{'background': options.bgColor, 'color':options.navColor}">
            <div class="img" @click="fanhui">
                <img v-if="options.bgColor == ''" src="../assets/localImage/return.png" alt="">
                <img v-else src="../assets/localImage/returnb.png" alt="">
            </div>
            <h2>{{title}}</h2>
            <!-- <button @click="handle()">{{operation}}</button> -->
            <slot><button></button></slot>
        </div>
        <div class="zhanwei" v-if="isFixed"></div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
            
            };
        },
        props: {
            title: {
                type:String,
                default:'',
                required:false
            },
            returnValue: {
                type:String,
                default:'1',
                required:false
            },
            // operation: {
            //     type:String,
            //     default:'',
            //     required:false
            // },
            isFixed:{
                type:Boolean,
                default:true,
                required:false
            },
            options: {
				type: Object,
				default() {
					return {
						// 面板背景色
						bgColor: '',
						// 导航字体颜色
						navColor: '#000000',
					} 
				}
			},
        },
        created(){
        },
        methods: {
            fanhui(){
                this.$router.go(-this.returnValue)
            }
        }
    }
</script>
<style scoped lang='less'>
.location{position: fixed;top: 0;left: 0; right: 0;z-index: 100;}
.zhanwei{height: 89px;}
.topTitle{
    padding: 0 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    height: 89px;

    .img{
        width: 20px;
        height: 36px;
    }
    h2{
        font-weight:500;
        font-size:36px;
        // color: ;
    }
    button{
        font-size:26px;
        font-weight:400;
        background-color: #ffffff;
        color: #000000;
    }
    
}
    
</style>